import React from 'react';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const handleStartProjectClick = () => {
    // Navigate to the contact page or a specific form
    window.location.href = '/contactpage';
  };

  const handleScheduleConsultationClick = () => {
    // Navigate to a scheduling tool or contact page
    window.location.href = '/contactpage';
  };

  return (
    <section className="py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
          Ready to Build Something Amazing?
        </h2>
        <p className="text-lg text-muted-foreground mb-8">
          Let's discuss how we can bring your vision to life with innovative technology solutions.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Button
            variant="default"
            iconName="MessageCircle"
            iconPosition="right"
            className="btn-conversion"
            onClick={handleStartProjectClick}
          >
            Start a Project
          </Button>
          <Button
            variant="outline"
            iconName="Calendar"
            iconPosition="right"
            onClick={handleScheduleConsultationClick}
          >
            Schedule Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;